import React from 'react';
import { FormattedMessage } from 'react-intl';

class PaymentsHistoryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        isRunningCall: false,
        error: "",
        text: "",
        payments: []
    };
  }

  componentDidMount() {
    this.props.eventToGAnalitycs("payment_history_show");
    this.getHistory();
  }
 
  getHistory = async () => {
    const topic = this.props.tinode.getMeTopic();  
    const query = topic.startMetaQuery().withDesc().build();
    query.desc.inchatgpttype = "paymentshistory";
    
    try {
      const result = await topic.getMeta(query);
      if (!result || result.desc.outchatgpt === "") {
        this.setError(this.props.intl.formatMessage({ id: "phistory.error" }) + " (1001)");
      } else {
        const text = result.desc.outchatgpt;
        this.setState({ payments: JSON.parse(text) });
        this.setIsRunningCall(false);
        console.log('Success:', result);
      }
    } catch (error) {
      console.error('Error:', error);
      this.setError(this.props.intl.formatMessage({ id: "phistory.error" }) + " (1001)");
      this.setIsRunningCall(false);
    } finally {
      this.setIsRunningCall(false);
    }
  }
 
  setIsRunningCall(value) {
    this.setState({ isRunningCall: value });
  }

  setError(value) {
    this.setState({ error: value });
  }

    renderService(service) {
      return service === 1 ? "YouKassa" : "---";
    }
  
    renderStatus(status) {
      switch (status) {
        case 1:
          return <FormattedMessage id="status.inProgress" defaultMessage="In progress" />;
        case 2:
          return <FormattedMessage id="status.success" defaultMessage="Success" />;
        case 3:
          return <FormattedMessage id="status.canceled" defaultMessage="Canceled" />;
        case 4:
          return <FormattedMessage id="status.error" defaultMessage="Error" />;
        default:
          return "---";
      }
    }


  
    renderTable() {
      const { payments } = this.state;
      if (payments.length > 0) {
        return (
          <table className="phistory-table">
            <thead>
              <tr>
                <th><FormattedMessage id="table.date" defaultMessage="Date" /></th>
                <th><FormattedMessage id="table.service" defaultMessage="Service" /></th>
                <th><FormattedMessage id="table.cost" defaultMessage="Cost" /></th>
                <th><FormattedMessage id="table.currency" defaultMessage="Currency" /></th>
                <th><FormattedMessage id="table.tokens" defaultMessage="Tokens" /></th>
                <th><FormattedMessage id="table.status" defaultMessage="Status" /></th>
                <th><FormattedMessage id="table.action" defaultMessage="Action" /></th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <tr key={index}>
                  <td>{new Date(payment.PayDate).toLocaleString()}</td>
                  <td>{this.renderService(payment.Service)}</td>
                  <td>{payment.Cost}</td>
                  <td>{payment.Curr}</td>
                  <td>{payment.Tokens}</td>
                  <td>{this.renderStatus(payment.Status)}</td>
                  <td>
                    {payment.Status !== 2 && (
                      <button className='link'  style={{ marginLeft: '3px' }} onClick={() => this.props.checkPayment(payment.Token, payment.Service,payment.Cost,payment.Curr )}>
                        <FormattedMessage id="button.checkStatus" defaultMessage="Check status" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      } else {
        return <div><FormattedMessage id="noPaymentHistory" defaultMessage="No payment history available." /></div>;
      }
    }
  

  render() {
    return (
      <div className='phistory-overlay'>
        <div className='phistory-container'>
            <div className="cancel">
                <a href="#" onClick={e => {e.preventDefault(); this.props.onCancel();}}><i className="material-icons gray">close</i></a>
            </div>
            <div>
            <h2>
                <FormattedMessage id="paymenthistory" defaultMessage="Payment history" description="Payment history" />
            </h2>
          </div>
          {this.renderTable()}

          <div className="bpanel margin-top-big"  >
               
               <span key={this.props.TokensUsed}> <FormattedMessage id="tokens" defaultMessage="Tokens:" description="Tokens:"/> {' '}  { this.props.TokensUsed} {'/'}   {this.props.Tokens} </span>

            
              <button id='linkTopUp' className='link'  style={{ marginLeft: '5px' }}
                    onClick={() => { this.props.onCancel(); this.props.onAddTokens();}}>
                     <FormattedMessage id="topup" defaultMessage="Top up" description="Top up"/>
              </button>
                
              </div>

        </div>

       
            
             
            


      </div>
    );
  }
}

export default PaymentsHistoryComponent;
